import { useQuery, useMutation, } from "@tanstack/react-query";
export const createLeaguesQueries = (requests, queryClient) => ({
    useListLeagues: (params, options = {}) => useQuery({
        queryKey: ["leagues", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listLeagues(params);
        },
        ...options,
    }),
    useFindLeague: (params, options = {}) => useQuery({
        queryKey: ["leagues", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findLeague(params);
        },
        ...options,
    }),
    useCreateLeague: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.createLeague(attrs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["leagues"] });
            queryClient.invalidateQueries({ queryKey: ["league"] });
        },
        ...options,
    }),
    useUpdateLeague: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.updateLeague(attrs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["leagues"] });
            queryClient.invalidateQueries({ queryKey: ["league"] });
        },
        ...options,
    }),
    useRecalculateStandings: (options = {}) => useMutation({
        ...options,
        mutationFn: (id) => {
            return requests.recalculateStandings(id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["leagues"] });
            queryClient.invalidateQueries({ queryKey: ["league"] });
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map